import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

/* Outer container */
export const PageContainer = styled(Box)({
    display: 'flex',
    height: '100vh',
    backgroundColor: '#f4f6f8',
});

/* Content wrapper */
export const ContentContainer = styled(Box)({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    padding: '24px',
});

/* Vertical stacking */
export const VerticalPaddingContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    paddingBottom: theme.spacing(3),
}));

/* Each block styled like a step card */
export const SectionCard = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'status',
})(({ theme, status }) => {
    let styles = {
        borderRadius: '12px',
        padding: theme.spacing(3),
        transition: 'all 0.2s ease-in-out',
    };

    if (status === 'completed') {
        styles = {
            ...styles,
            backgroundColor: '#e6f4ea',
            border: '2px solid #34a853',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        };
    } else if (status === 'active') {
        styles = {
            ...styles,
            backgroundColor: '#fff',
            border: '2px solid #4285f4',
            boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
        };
    } else {
        styles = {
            ...styles,
            backgroundColor: '#f0f0f0',
            border: '2px dashed #ccc',
            opacity: 0.6,
            pointerEvents: 'none',
        };
    }

    return styles;
});

/* Section headers */
export const SectionTitle = styled(Typography)(({ theme }) => ({
    fontSize: '1.1rem',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: theme.palette.grey[800],
}));
